import { Node, mergeAttributes } from '@tiptap/core';
const LIST_EXT_NAME = 'productFeatureList';
const ITEM_EXT_NAME = 'productFeatureListItem';
const ITEM_NAME_EXT_NAME = 'productFeatureListItemName';
const ITEM_DESC_EXT_NAME = 'productFeatureListItemDescription';
export const ProductFeatureListItemName = Node.create({
    name: ITEM_NAME_EXT_NAME,
    group: ITEM_EXT_NAME,
    content: 'text*',
    draggable: false,
    isolating: true,
    marks: '_',
    addOptions() {
        return {
            tagName: 'mb-product-feature-list-item-name',
        };
    },
    parseHTML() {
        return [
            {
                tag: this.options.tagName,
            },
        ];
    },
    renderHTML({ HTMLAttributes }) {
        return [this.options.tagName, mergeAttributes(HTMLAttributes), ['h3', 0]];
    },
});
export const ProductFeatureListItemDescription = Node.create({
    name: ITEM_DESC_EXT_NAME,
    group: ITEM_EXT_NAME,
    content: 'paragraph+',
    draggable: false,
    isolating: true,
    marks: '_',
    addOptions() {
        return {
            tagName: 'mb-product-feature-list-item-description',
        };
    },
    parseHTML() {
        return [
            {
                tag: this.options.tagName,
            },
        ];
    },
    renderHTML({ HTMLAttributes }) {
        return [this.options.tagName, mergeAttributes(HTMLAttributes), ['p', 0]];
    },
});
export const ProductFeatureListItem = Node.create({
    name: ITEM_EXT_NAME,
    group: LIST_EXT_NAME,
    content: `${ITEM_NAME_EXT_NAME} ${ITEM_DESC_EXT_NAME}`,
    marks: '_',
    isolating: true,
    draggable: true,
    addOptions() {
        return {
            tagName: 'mb-product-feature-list-item',
        };
    },
    parseHTML() {
        return [
            {
                tag: this.options.tagName,
            },
        ];
    },
    renderHTML({ HTMLAttributes }) {
        return [this.options.tagName, mergeAttributes(HTMLAttributes), 0];
    },
});
export const ProductFeatureList = Node.create({
    name: LIST_EXT_NAME,
    group: 'block',
    content: `${ITEM_EXT_NAME}*`,
    atom: true,
    draggable: true,
    addOptions() {
        return {
            tagName: 'mb-product-feature-list',
        };
    },
    addCommands() {
        return {
            addProductFeatureList: () => ({ commands }) => {
                return commands.insertContent({
                    type: this.name,
                    content: [
                        {
                            type: ITEM_EXT_NAME,
                            content: [
                                { type: ITEM_NAME_EXT_NAME },
                                {
                                    type: ITEM_DESC_EXT_NAME,
                                    content: [{ type: 'paragraph' }],
                                },
                            ],
                        },
                        {
                            type: ITEM_EXT_NAME,
                            content: [
                                { type: ITEM_NAME_EXT_NAME },
                                {
                                    type: ITEM_DESC_EXT_NAME,
                                    content: [{ type: 'paragraph' }],
                                },
                            ],
                        },
                    ],
                });
            },
        };
    },
    parseHTML() {
        return [
            {
                tag: this.options.tagName,
            },
        ];
    },
    renderHTML({ HTMLAttributes }) {
        return [this.options.tagName, mergeAttributes(HTMLAttributes), 0];
    },
});
//# sourceMappingURL=product-feature-list.js.map